import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, Layout, message } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { logout } from '../services/api';

const { Sider } = Layout;

const Sidebar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('user');
    message.success('已退出登录');
    logout();
    navigate('/login');
  };

  return (
    <Sider
      width={200}
      style={{
        overflow: 'auto',
        height: '100vh',
        background: '#001529',
      }}
    >
      <Menu theme="dark" mode="inline" style={{ height: '100%' }}>
        <Menu.Item key="home">
          <Link to="/dashboard">首页</Link>
        </Menu.Item>
        <Menu.Item key="coupons">
          <Link to="/dashboard/coupons">优惠券管理</Link>
        </Menu.Item>
        <Menu.Item key="users">
          <Link to="/dashboard/users">用户管理</Link>
        </Menu.Item>
        <Menu.Item key="user-test">
          <Link to="/dashboard/user-test">用户测试</Link>
        </Menu.Item>
        <Menu.Item
          key="logout"
          icon={<LogoutOutlined />}
          onClick={handleLogout}
          style={{ marginTop: 'auto' }}
        >
          退出登录
        </Menu.Item>
      </Menu>
    </Sider>
  );
};

export default Sidebar;
